

module.exports = __webpack_require__.stylable.create(
    "Description2091544166",
    {"classes":{"root":"Description2091544166__root"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    2,
    "Description2091544166",
    null
);
